var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.816,
    height: 24.725,
    viewBox: "0 0 16.816 24.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_391",
    "data-name": "Grupo 391",
    transform: "translate(-0.078 0.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_549",
    "data-name": "Trazado 549",
    d: "M16.316,12.082V24.735a1.581,1.581,0,0,1-1.582,1.582H2.082A1.586,1.586,0,0,1,.5,24.735V12.082A1.586,1.586,0,0,1,2.082,10.5H14.735A1.581,1.581,0,0,1,16.316,12.082Z",
    transform: "translate(0.078 -2.105)",
    fill: "none",
    stroke: "#868686",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_550",
    "data-name": "Trazado 550",
    d: "M14.571,6.036V8.408H3.5V6.036a5.536,5.536,0,1,1,11.071,0Z",
    transform: "translate(-0.55 -0.013)",
    fill: "none",
    stroke: "#868686",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_551",
    "data-name": "Trazado 551",
    d: "M13.057,6.768V8.99H6.09V6.768A3.483,3.483,0,0,1,9.578,3.28a3.483,3.483,0,0,1,3.48,3.488Z",
    transform: "translate(-1.091 -0.595)",
    fill: "none",
    stroke: "#868686",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.ac8dac7172fda203e0437d30a3b912de.svg";
export { ForwardRef as ReactComponent };